export default {"src":"/_next/static/image/public/images/ic_technical_error.be2181cd697d9435a5238c5d054b05f8.svg","height":137,"width":189};